import type { ITheme } from '../../../utils/theme';

export const getStyledAriaSelectBorderRadius = (
  open: boolean,
  $isTop: boolean,
  theme: ITheme
) => {
  if (open) {
    return $isTop
      ? `0px 0px ${theme.borderRadius.sm} ${theme.borderRadius.sm}`
      : `${theme.borderRadius.sm} ${theme.borderRadius.sm} 0 0`;
  }
  return theme.borderRadius.sm;
};
